module.exports = __webpack_public_path__ + "media/images/icons/smartfone-active-a9d8bfcf08f73dc7b626d933b9b0c3fe.png";